import { render, staticRenderFns } from "./ItemSize.vue?vue&type=template&id=4136953c&scoped=true"
import script from "./ItemSize.vue?vue&type=script&lang=js"
export * from "./ItemSize.vue?vue&type=script&lang=js"
import style0 from "./ItemSize.vue?vue&type=style&index=0&id=4136953c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4136953c",
  null
  
)

export default component.exports